import { useEffect, useState } from 'react';
import '../../scss/backoffice.scss';
import { Sidemenu } from './Sidemenu';
import { Topbar } from './Topbar';
import { Footer } from './Footers';
import LinceChartV2 from './LinceChartV2';
import {
  RequestsDashboardTop,
  LineChartDasboard,
  LineChartRequests,
  LineChartApproveds,
} from '../../model/datatype';
import { AnnouncementsData, GetAnnouncement } from '../../model/datatype';
import { getAnnouncementList } from '../../services/ApiGetAnnouncementList';
import { setRequestDashboard } from '../../services/ApiGetDashboardRequests';
import { getChartAmount } from '../../services/ApiGetChartAmount';
import CountUp from 'react-countup';
import Moment from 'moment';
import { useNavigate } from 'react-router-dom';

export const Dashboard = (props: any) => {
  const [dataAnnouncement, setDataAnnouncement] =
    useState<AnnouncementsData | null>(null);
  const [data, setData] = useState<RequestsDashboardTop | null>(null);
  const [dataChart, setDataChart] = useState<LineChartDasboard | null>(null);
  const [dataRequests, setDataRequests] = useState(null);
  const [dataApproveds, setDataApproveds] = useState(null);
  const [dataMonth, setDataMonth] = useState(null);
  const [apiCalled, setApiCalled] = useState<any>(false);
  const [displayFullScreenLoading, setDisplayFullScreenLoading] =
    useState(false);

  const [showScrollTop, setShowScrollTop] = useState(false);

  const handleScroll = () => {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    setShowScrollTop(scrollY > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  let navigate = useNavigate();

  const date = new Date(); // date object
  const getYear = date.getFullYear(); // get current year
  const getMonth = date.getMonth() + 1; // get current year
  //console.log(getMonth);
  function dataToArrayRequests(items: LineChartDasboard | null) {
    //console.log('items=', items);
    try {
      let arrRequests: any = [];
      if (items && items.requests) {
        items.requests.map((item: any, index: any) => {
          arrRequests.push(item.total);
        });
      }

      //console.log('arrRequests=', arrRequests);
      return arrRequests;
    } catch (error) {
      // console.error(error);
      return [];
    }
  }

  function dataToArrayApproved(items: LineChartDasboard | null) {
    try {
      let arrApproveds: any = [];
      if (items && items.approveds) {
        items.approveds.map((item: any, index: any) => {
          arrApproveds.push(item.total);
        });
      }
      //console.log('arrApproveds=', arrApproveds);
      return arrApproveds;
    } catch (error) {
      // console.error(error);
      return [];
    }
  }

  function getMonthName(items: LineChartDasboard | null) {
    try {
      const monthNames = [
        '',
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      let arrMonthName: any = [];
      if (items && Array.isArray(items.approveds)) {
        items.approveds.map((item: any, index: any) => {
          arrMonthName.push(monthNames[item.month]);
        });
      }
      return arrMonthName;
    } catch (error) {
      return [];
    }
  }
  let count = 0;
  //console.log('dataMonth=', dataMonth);
  useEffect(() => {
    setDisplayFullScreenLoading(true);
    if (dataChart === null) {
      getChartAmount(getYear).then((response) => {
        // console.log('response=', response);
        //console.log('xxxxxxxxxxxxxxx');
        setApiCalled(true);
        setDataMonth(getMonthName(response));
        setDataRequests(dataToArrayRequests(response));
        setDataApproveds(dataToArrayApproved(response));
        setDataChart(response);
        count++;
      });
    }

    setRequestDashboard(getYear, getMonth).then((response) => {
      const getData: any = response;
      setData(getData);
      setDisplayFullScreenLoading(false);
    });

    getAnnouncementList(0, 3, 'dashboard').then((response) => {
      const getDataAnn: any = response;
      setDataAnnouncement(getDataAnn);
    });
  }, [dataRequests, dataApproveds, dataMonth, apiCalled]);

  //console.log('apiCalled=', apiCalled);

  //console.log(dataAnnouncement);

  //console.log('dataRequests=', dataRequests);
  //console.log('dataApproveds=', dataApproveds);

  function hanleMore(item: GetAnnouncement) {
    navigate('/anouncement/' + item.id, { state: item });
  }

  return (
    <>
      <div className="container-fiuld master-layout dashboard-fullscreen">
        <Sidemenu displayFullScreenLoading={displayFullScreenLoading} />
        <div className="main-container">
          <div className="col-12 mb-0">
            <Topbar />
          </div>
          <div className="container-fuild  mt-4">
            <div className="dashboard-row-container">
              <div className="dashboard-top-section animated-element">
                <div className="block-shadow dashboard-card salary-requests-card">
                  <div className="card-header">
                    <h3>Total Amount Request</h3>
                    <div className="text-end">
                      {/* <p className="noted">Updated last month </p> */}
                    </div>
                  </div>
                  <div className="card-body py-2">
                    <div className="stats-container">
                      <div className="stat-card total">
                        <div className="stat-icon">
                          <img src="../../../images/backoffice/users-all.png" alt="All requests" />
                        </div>
                        <div className="stat-content total-color">
                          <label>
                            <CountUp
                              delay={2}
                              start={0}
                              end={data?.total}
                              separator=","
                            />
                          </label>
                          <p className="mb-0">Total Requests</p>
                        </div>
                      </div>
                      <div className="stat-card pending">
                        <div className="stat-icon">
                          <img src="../../../images/backoffice/user-pending.png" alt="Pending requests" />
                        </div>
                        <div className="stat-content pending-color">
                          <label>
                            <CountUp
                              delay={2}
                              start={0}
                              end={data?.pendingTotal}
                              separator=","
                            />
                          </label>
                          <p className="mb-0">Pending</p>
                        </div>
                      </div>
                      <div className="stat-card rejected">
                        <div className="stat-icon">
                          <img src="../../../images/backoffice/user-reject.png" alt="Rejected requests" />
                        </div>
                        <div className="stat-content reject-color">
                          <label>
                            <CountUp
                              delay={2}
                              start={0}
                              end={data?.rejectedTotal}
                              separator=","
                            />
                          </label>
                          <p className="mb-0">Rejected</p>
                        </div>
                      </div>
                      <div className="stat-card approved">
                        <div className="stat-icon">
                          <img src="../../../images/backoffice/user-approved.png" alt="Approved requests" />
                        </div>
                        <div className="stat-content approved-color">
                          <label>
                            <CountUp
                              delay={2}
                              start={0}
                              end={data?.approvedTotal}
                              separator=","
                            />
                          </label>
                          <p className="mb-0">Approved</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="dashboard-middle-section animated-element">
                <div className="block-shadow dashboard-card salary-requests-card">
                  <div className="card-header">
                    <h3>Total Amount Request Overview</h3>
                    <div className="text-end">
                      {/* <p className="noted">Monthly data </p> */}
                    </div>
                  </div>
                  <div className="row align-items-center h-100">
                    <div className="col-8 text-center hr-chart-container">
                      <LinceChartV2
                        requests={dataRequests}
                        approved={dataApproveds}
                        month={dataMonth}
                        apiCalled={apiCalled}
                      />
                    </div>
                    <div className="col-4 p-5 border-start text-center compare-approved hr-chart-container">
                      <label className="purle-color">
                        <CountUp
                          delay={1}
                          start={0}
                          end={dataChart?.totalReqeust}
                          separator=","
                        />{' '}
                        Bath
                      </label>
                      <p className="mb-5">Total Amount Request</p>
                      <label className="orange-color">
                        <CountUp
                          delay={1}
                          start={0}
                          end={dataChart?.totalApproved}
                          separator=","
                        />{' '}
                        Bath
                      </label>
                      <p className="mb-0">Total amount Approved</p>
                    </div>
                  </div>
                </div>
              </div>
              
              {dataAnnouncement && dataAnnouncement?.announcements.length > 0 ? (
                <div className="dashboard-bottom-section animated-element">
                  <div className="block-shadow dashboard-card salary-requests-card">
                    <div className="card-header">
                      <h3>Latest Announcement</h3>
                      <div className="text-end">
                        {/* <p className="noted">Updated content</p> */}
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="announcement-cards-container">
                        {dataAnnouncement !== null ? (
                          dataAnnouncement.announcements.length > 0 ? (
                            dataAnnouncement?.announcements.map(
                              (item: GetAnnouncement, index: number) => (
                                <div className="col-12 col-sm-4 col-md-4" key={index}>
                                  <div
                                    className="block-shadow top-annoucement"
                                    onClick={() => hanleMore(item)}
                                  >
                                    <div className="announcement-image-container">
                                      <img
                                        src={
                                          'data:image/jpg;base64,' + item?.thumnail
                                        }
                                        className="announcement-thumbnail"
                                        alt={item.subjectTh}
                                      />
                                    </div>
                                    <div className="announcement-content">
                                      <h4 className="emp-name">{item.subjectTh}</h4>
                                      <p className="p-date">
                                        <img
                                          src="../../../images/backoffice/calendar.png"
                                          width={20}
                                          alt="Calendar icon"
                                        />{' '}
                                        {Moment(item?.createdDateTime).format(
                                          'DD MMM YYYY',
                                        )}
                                      </p>
                                      <p className="text-shot">
                                        {item.shortDetailsTh}
                                      </p>
                                      <button className="read-more-btn" onClick={(e) => {
                                        e.stopPropagation();
                                        hanleMore(item);
                                      }}>
                                        Read More
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )
                            )
                          ) : (
                            <div className="loader-data text-notfound text-center">
                              data notfound
                            </div>
                          )
                        ) : (
                          <div className="loader-data">
                            <div className="spinner"></div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>

            <div className="col-12">
              <Footer />
            </div>
          </div>
        </div>
      </div>
      {showScrollTop && (
        <div className="scroll-to-top visible" onClick={scrollToTop}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
          </svg>
        </div>
      )}
    </>
  );
};
